import {assertTokenValidForMutation, handleResponse} from "@/services/service-helpers.ts";
import {Driver} from "@/models/driver.ts";
import log from '@/lib/logger';

const NBH_DRIVERS_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/drivers`

export async function getDrivers(
    token: string | null
): Promise<Driver[]> {
    if (!token) {
        log.error("No token provided to request drivers");
        return Promise.reject("No token provided");
    }

    const response = await fetch(NBH_DRIVERS_BASE_URL, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        })
    });

    const result = await handleResponse<Driver[]>(response)
    return result || []
}

export async function updateDriverCurrentNotes(
    token: string | null,
    driverId: string,
    currentNotes: string | null,
): Promise<void> {
    if (!token) {
        log.error("No token provided to update driver current notes");
        return Promise.reject("No token provided");
    }
    assertTokenValidForMutation()

    const response = await fetch(`${NBH_DRIVERS_BASE_URL}/${driverId}/current-notes`, {
        method: 'PATCH',
        headers: new Headers({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({currentNotes})
    });

    await handleResponse<void>(response)
}
